import React from 'react';
import SVG from 'react-inlinesvg';
import './EventItem.scss';
import { Link } from 'react-router-dom';
import { EventImageType, EventTypeModel } from '../../../data/EventTypeModel';
import { SYSTEM_DEVICE } from '../../../hooks/useSystemDevice';

export interface Props {
  className?: string;
  eventType: EventTypeModel;
  imageType: EventImageType;
}

const EventItem: React.FC<Props> = (props) => {
  const scope = 'EventItem';

  const className = [scope, props.className]
    .filter((className) => className)
    .join(' ');

  return (
    <Link to={props.eventType.linkPath} className={className}>
      <img
        alt={props.eventType.attrs.name}
        className={`${scope}-picture`}
        src={props.eventType.getImageSrc(props.imageType, SYSTEM_DEVICE.MOBILE)}
      />
      <div className={`${scope}-body`}>
        <div className={`${scope}-info`}>
          <div className={`${scope}-date`}>{props.eventType.weekDays}</div>
          <div className={`${scope}-name`}>{props.eventType.attrs.name}</div>
        </div>
        <SVG
          className={`${scope}-arrow`}
          src={`${process.env.PUBLIC_URL}/media/arrow-right-1.svg`}
        />
      </div>
    </Link>
  );
};

export default EventItem;
